import React from "react";
import clsx from "clsx";

export default function CircularProgressBar({
  percent,
  activeStroke = "#4F47E5",
  textStyle,
  className,
  size = 60,
  strokeWidth = 12,
  strokeColor = "#E5E5E5",
}: {
  percent: number;
  activeStroke?: string;
  textStyle?: string;
  className?: string;
  size?: number;
  strokeWidth?: number;
  strokeColor?: string;
}) {
  const circumference = (size - strokeWidth) * 2 * Math.PI;

  return (
    <div className="flex items-center justify-center overflow-hidde rounded-full relative">
      <svg
        className={clsx(
          `svg-indicator w-32 h-32 relative -rotate-90`,
          className
        )}
      >
        <circle
          strokeWidth={strokeWidth}
          fill="transparent"
          cx={size}
          cy={size}
          r={size - strokeWidth}
          className="svg-indicator-track"
          stroke={strokeColor}
        />
        <circle
          strokeWidth={strokeWidth}
          cx={size}
          cy={size}
          r={size - strokeWidth}
          fill="transparent"
          className="svg-indicator-indication"
          stroke={activeStroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - (percent / 100) * circumference}
        />
      </svg>
      <span
        className={`absolute mt-2 mr-1 text-2xl mx-auto ${
          textStyle || "text-indigo-700"
        }`}
      >{`${percent}%`}</span>
    </div>
  );
}
